import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { ProductTypes } from "../../../public/landingPage/components/productTypes";
import CheckCircleIcon from "@mui/icons-material/CheckCircleOutline";
import {
  getPastOrderDataDetailsAsync,
  getBillDetailsAsync,
  paymentCustomOrderCheckoutAsync,
} from "../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Footer } from "../../../../layouts/footer";
import DownloadIcon from "@mui/icons-material/Download";
import { showSnackbar } from "../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { getPastOrderListAsync } from "../../../../../app/slices/pastOrderSlice/PastOrderSlice";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { PAYU_URL } from "../../../../../api/payu/Api";

export const OrderConfirmation = () => {
  const [localconfirmedOrder, setlocalconfirmedOrder] = useState({}) as any;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { profileData }: any = useAppSelector((state) => state.ProfileState);
  const [isLoading, setIsLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uuidFromPastOrder, setuuidFromPastOrder] = useState();
  const [availablePaymentModes, setAvailablePaymentModes] = useState([]) as any;
  const [selectedPaymentModeId, setSelectedPaymentModeId] = useState<
    number | null
  >(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getPastOrderListAsync()).then((response: any) => {
      if (response?.payload?.status === 200) {
        setuuidFromPastOrder(response?.payload?.data?.orders?.[0]?.uuid);
      }
    });
  }, []);
  useEffect(() => {
    const orderUUID = localStorage.getItem("order_uuid");
    if (orderUUID) {
      setIsLoading(true);
      dispatch(getPastOrderDataDetailsAsync(orderUUID)).then(
        (response: any) => {
          if (response?.payload?.status === 200) {
            setlocalconfirmedOrder(response?.payload?.data?.order_details);
            setAvailablePaymentModes(
              response?.payload?.data?.available_payment_modes
            );
            if (response?.payload?.data?.available_payment_modes?.length > 0) {
              // prefer the first mode if none selected yet
              if (!selectedPaymentModeId)
                setSelectedPaymentModeId(
                  Number(response?.payload?.data?.available_payment_modes[0].id)
                );
            }
            setIsLoading(false);
          }
        }
      );
    } else if (!orderUUID && uuidFromPastOrder) {
      setIsLoading(true);
      dispatch(getPastOrderDataDetailsAsync(uuidFromPastOrder)).then(
        (response: any) => {
          if (response?.payload?.status === 200) {
            setlocalconfirmedOrder(response?.payload?.data?.order_details);
            setAvailablePaymentModes(
              response?.payload?.data?.available_payment_modes
            );
            if (response?.payload?.data?.available_payment_modes?.length > 0) {
              // prefer the first mode if none selected yet
              if (!selectedPaymentModeId)
                setSelectedPaymentModeId(
                  Number(response?.payload?.data?.available_payment_modes[0].id)
                );
            }
            setIsLoading(false);
          }
        }
      );
    } else {
      const localconfirmedOrder2 = JSON.parse(
        localStorage.getItem("orderDetails") as any
      );
      setlocalconfirmedOrder(localconfirmedOrder2);
    }
  }, [, uuidFromPastOrder]);

  const convertTimeTo12HourFormat = (time: string): string => {
    if (!time) {
      return ""; // Return a fallback string if time is undefined or falsy
    }

    const [hours, minutes] = time.split(":").map(Number);
    const isPM = hours >= 12;
    const formattedHours = hours % 12 || 12; // Converts 00:00 to 12:00 for midnight
    const formattedMinutes = minutes?.toString().padStart(2, "0");
    const period = isPM ? "PM" : "AM";

    return `${formattedHours}:${formattedMinutes} ${period}`;
  };

  const convertDateToMMDDYYYY = (date: string): string => {
    let year, month, day;
    if (date) {
      [year, month, day] = date.split("-");
    }
    return year && month && day ? `${month}/${day}/${year}` : "";
  };

  const formatDateToMMDDYYYY = (date: string): string => {
    if (date !== "Invalid Date") {
      const d = new Date(date);

      const month = String(d?.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(d?.getDate()).padStart(2, "0");
      const year = d?.getFullYear();

      const hours24 = d?.getHours();
      const minutes = String(d?.getMinutes()).padStart(2, "0");

      // Convert to 12-hour format
      const isPM = hours24 >= 12;
      const hours12 = hours24 % 12 || 12; // 12 is for midnight and noon
      const period = isPM ? "PM" : "AM";

      return `${month}/${day}/${year} ${hours12}:${minutes} ${period}`;
    } else return "";
  };
  const convertTimeFormat = (createdDate: any | undefined) => {
    if (createdDate && createdDate !== "Not Provided") {
      const date = new Date(createdDate);

      const day = date.getDate();
      const month = date.toUTCString().split(" ")[2];
      const year = date.getFullYear().toString().slice(-2);
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const isPM = hours >= 12;
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes.toString().padStart(2, "0");
      const period = isPM ? "PM" : "AM";

      return `${day}th ${month} ${year} - ${formattedHours}:${formattedMinutes}${period}`;
    }
    return "";
  };

  const handleCheckoutClick = async (orderId: any) => {
    try {
      const payload: any = {
        order_id: orderId,
        delivery_mode: selectedPaymentModeId,
      };

      const response: any = await dispatch(
        paymentCustomOrderCheckoutAsync(payload)
      );

      console.log("Custom Order Checkout API Response:", response);
     

      if (selectedPaymentModeId === 1 && response?.payload?.status === 1) {
        dispatch(
          showSnackbar({
            message: "Order placed successfully with COD",
            severity: "success",
            autoHide: 3000,
          })
        );
        window.location.reload();
        navigate("/order-confirmation");
      } else if (
        response?.payload?.data?.status === 1 &&
        response?.payload?.data?.params &&
        response?.payload?.data?.params?.key
      ) {
        // Handler for new JSON response format with payu_url and params
        console.log("PayU params found, redirecting...", response?.payload?.data?.params);
        redirectToPayU(
          response?.payload?.data?.params,
          response?.payload?.data?.payu_url || PAYU_URL
        );
      } else {
        dispatch(
          showSnackbar({
            message: "Failed to initiate PayU payment",
            severity: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        showSnackbar({ message: "Something went wrong.", severity: "error" })
      );
    }
  };

  const orderDate = new Date(localconfirmedOrder?.created_date);
  const handleDownload = () => {
    const orderId = localconfirmedOrder?.order_ID;
    if (!orderId || downloading) return; // ⛔ Prevent multiple clicks

    setDownloading(true); // 🚀 Lock
    setProgress(0);

    // Simulate progress bar while waiting for API
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 90) return oldProgress; // stop at 90%, final 100% after success
        return oldProgress + 10;
      });
    }, 300);

    dispatch(getBillDetailsAsync(orderId))
      .then((response: any) => {
        if (response?.payload?.status === 200) {
          const blob = new Blob([response.payload.data], {
            type: "application/pdf",
          });
          const url = window.URL.createObjectURL(blob);

          // ✅ Open in new tab
          window.open(url, "_blank");

          // ✅ Optional force download
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Bill-${response.meta.arg}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
        setDownloading(false); // 🔓 Unlock
      })
      .finally(() => {
        clearInterval(interval);
        setProgress(100); // ✅ complete
        setTimeout(() => {
          setDownloading(false);
          setProgress(0);
        }, 500); // small delay before resetting
      })
      .catch(() => {
        setDownloading(false); // 🔓 Unlock on error too
        setProgress(0);
      });
  };
 // Helper function to create and submit PayU form
  const redirectToPayU = (params: any, payuUrl: string) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = payuUrl;

    Object.entries(params).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = String(value ?? "");
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <>
      <ResponsiveAppBar />
      <ProductTypes />
      <div className="tf-breadcrumb">
        <div className="container">
          <div className="tf-breadcrumb-wrap d-flex justify-content-between flex-wrap align-items-center">
            <div className="tf-breadcrumb-list">
              <a className="text" onClick={() => navigate("/")}>
                Home
              </a>
              <i className="icon icon-arrow-right"></i>
              <span className="text">My Order</span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <div className="row">
          {isLoading ? (
            <div className="col-md-8">
              <div style={{ minHeight: "50vh" }}>
                <CircularProgress
                  style={{
                    position: "absolute",
                    // top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />
              </div>
            </div>
          ) : (
            <>
              {/* <div className="row"> */}
              <div
                className="col-md-8"
                style={
                  !localconfirmedOrder?.grand_total ? { marginLeft: "18%" } : {}
                }
              >
                {localconfirmedOrder?.order_status === "Failed" ? (
                  <>
                    <div className="mb-3 failed-order p-3">
                      <div className="row align-items-center justify-content-center ">
                        <div className="col-12 text-center">
                          <img src="images/status-fail.svg" width="50" alt="" />
                          <h6 className="my-2 fw-6">Order Failed</h6>
                          <p>
                            <b>
                              Your order has failed.
                              <br />
                              please contact the shop directly to initiate a
                              refund.{" "}
                              {localconfirmedOrder?.order_ID && (
                                <>Order Id: {localconfirmedOrder?.order_ID}</>
                              )}
                            </b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="mb-3 confirm-order">
                      <div className="row align-items-center justify-content-center">
                        <div className="col-12 text-center">
                          {/* <img src="images/success.svg" width="50" alt=""> */}
                          {/* <CheckIcon color="success" /> */}
                          <CheckCircleIcon
                            style={{
                              color: "green", // Green filled circle
                              fontSize: "50px", // Size of the icon
                            }}
                          />
                          {localconfirmedOrder?.order_type ===
                            "Custom Orders" &&
                          !localconfirmedOrder?.grand_total ? (
                            <>
                              <h6 className="my-2 fw-6">
                                Your Custom Cake Request is Submitted !
                              </h6>
                              <p>
                                <b className="address-text">
                                  Our Team is Reviewing your request.
                                  <br />
                                  You will hear from us shortly.
                                </b>
                              </p>
                            </>
                          ) : (
                            <>
                              <h6 className="my-2">Confirmed</h6>
                              <p className="address-text">
                                <b>
                                  Thank You !<br />
                                  Your Order has been Placed. Order Id:{" "}
                                  {localconfirmedOrder?.order_ID}
                                </b>
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="wd-form-order">
                  <div className="tf-grid-layout md-col-12 gap-15 border-dotted">
                    <div className="item">
                      {localconfirmedOrder?.order_type === "Custom Orders" && (
                        <>
                          <div className="d-flex justify-content-between">
                            <div className="ms-2">
                              <b>{localconfirmedOrder?.order_ID}</b>
                            </div>
                            <div className="ms-2">
                              {convertTimeFormat(
                                localconfirmedOrder?.created_date
                              )}
                            </div>
                          </div>
                          <hr className="dotted" />
                        </>
                      )}
                      <div className="row justify-content-between">
                        <div className="col ms-2">
                          {localconfirmedOrder?.order_type ===
                          "Long Distance Orders" ? (
                            <>
                              <div className="text-2 mt_4 fw-6">
                                {localconfirmedOrder?.pu_name}
                              </div>
                              <div>
                                <p>{localconfirmedOrder?.pu_location}</p>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="text-2 mt_4 fw-6">
                                {localconfirmedOrder?.shop_name}
                              </div>
                              <div>
                                <p>{localconfirmedOrder?.shop_location}</p>
                              </div>
                            </>
                          )}
                        </div>

                        <div className="col ms-2">
                          <div className="d-flex mt-2 align-items-center">
                            <div>
                              <i className="fa fa-circle-phone orange-txt fs-7"></i>
                            </div>
                            <div className="ms-2">
                              <div className="text-2 text_black-2">
                                <p>For Urgent Enquiries, Contact us at</p>
                              </div>
                              <div className="text-2 mt_4 fw-6">
                                <span>
                                  {localconfirmedOrder?.order_type ===
                                  "Long Distance Orders"
                                    ? `+91 ${localconfirmedOrder?.pu_contact}`
                                    : `+91 ${localconfirmedOrder?.shop_contact}`}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {localconfirmedOrder?.order_type !== "Pick Up" && (
                        <>
                          <hr className="dotted" />

                          <div className="row justify-content-between">
                            <div className="col ms-2">
                              <div className="d-flex mt-2">
                                <div>
                                  <i className="fa fa-map-marker-alt orange-txt"></i>
                                </div>
                                <div className="ms-2">
                                  <div className="text-2 text_black-2">
                                    {localconfirmedOrder?.address_type
                                      ?.toLowerCase()
                                      .replace(/\b\w/g, (char: any) =>
                                        char.toUpperCase()
                                      )}
                                  </div>
                                  <div className="text-2 mt_4 fw-6">
                                    {localconfirmedOrder?.address_1
                                      ? localconfirmedOrder?.address_1 + ","
                                      : ""}
                                    {localconfirmedOrder?.address_2}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col ms-2">
                              <div className="d-flex mt-2">
                                <div>
                                  <i className="fa fa-phone-alt orange-txt"></i>
                                </div>
                                <div className="ms-2">
                                  <div className="text-2 text_black-2">
                                    Phone
                                  </div>
                                  <div className="text-2 mt_4 fw-6">
                                    {profileData?.data?.phone_number}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {/* order for someone else */}
                      {localconfirmedOrder?.some_one_else_order?.name && (
                        <>
                          <hr className="dotted" />

                          <div className="row justify-content-between">
                            <div className="col ms-2">
                              <div className="d-flex mt-2">
                                <div className="ms-2">
                                  <div className="d-flex mt-2">
                                    <div>
                                      <i className="fa fa-user orange-txt"></i>{" "}
                                    </div>
                                    <div className="ms-2">
                                      <div className="text-2 text_black-2">
                                        Ordered For
                                      </div>
                                      <div className="text-2 mt_4 fw-6">
                                        {
                                          localconfirmedOrder
                                            ?.some_one_else_order?.name
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col ms-2">
                              <div className="d-flex mt-2">
                                <div>
                                  <i className="fa fa-phone-alt orange-txt"></i>
                                </div>
                                <div className="ms-2">
                                  <div className="text-2 text_black-2">
                                    Phone
                                  </div>
                                  <div className="text-2 mt_4 fw-6">
                                    {
                                      localconfirmedOrder?.some_one_else_order
                                        ?.phone_number
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {localconfirmedOrder?.order_type === "Custom Orders" && (
                    <div className="tf-grid-layout md-col-12 gap-15 border-dotted">
                      <div className="item">
                        <div
                          className="row"
                          style={{
                            paddingLeft: "15px",
                            paddingRight: "15px",
                          }}
                        >
                          <div className="col-12 mt-3 px-1">
                            <p>Product Selected</p>
                            <b>
                              {localconfirmedOrder?.custom_product?.item_name}
                            </b>
                          </div>
                        </div>
                        <div
                          className="row"
                          style={{
                            paddingLeft: "15px",
                            paddingRight: "15px",
                          }}
                        >
                          <div className="col-12 mt-3 px-1">
                            <p>Your Request</p>
                            <textarea
                              placeholder="description"
                              readOnly
                              name="description"
                              className="enq"
                              id="description"
                              value={localconfirmedOrder?.description}
                            ></textarea>
                          </div>
                        </div>
                        <div
                          className="row"
                          style={{
                            paddingLeft: "15px",
                            paddingRight: "15px",
                          }}
                        >
                          <div className="col-12 mt-3 px-1">
                            <p>Message on Cake</p>
                            <textarea
                              placeholder="Message"
                              readOnly
                              name="message"
                              className="enq"
                              id="message"
                              value={localconfirmedOrder?.message}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="widget-content-inner mt-3 border-dotted">
                    <div className="text-2 fw-6">Order Status</div>
                    <div className="widget-timeline">
                      <ul
                        className="timeline"
                        style={{ top: "7%", bottom: "6%" }}
                      >
                        {localconfirmedOrder?.order_status === "Failed" ? (
                          <>
                            <li>
                              <div className="timeline-badge failure"></div>
                              <div className="timeline-box">
                                <div className="text-2 fw-6">Order Failed</div>
                              </div>
                            </li>
                          </>
                        ) : (
                          <>
                            {localconfirmedOrder?.order_type ===
                              "Custom Orders" && (
                              <>
                                <li>
                                  <div
                                    className={
                                      localconfirmedOrder?.order_status ===
                                        "Enquiry" ||
                                      localconfirmedOrder?.order_status ===
                                        "Contacted" ||
                                      localconfirmedOrder?.order_status ===
                                        "Bill Created" ||
                                      // order?.order_status === "New Order" ||
                                      localconfirmedOrder?.order_status ===
                                        "Confirmed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Viewed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Order Packed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Delivery Assigned" ||
                                      localconfirmedOrder?.order_status ===
                                        "Dispatching" ||
                                      localconfirmedOrder?.order_status ===
                                        "Despatched" ||
                                      localconfirmedOrder?.order_status ===
                                        "Delivered" ||
                                      localconfirmedOrder?.order_status ===
                                        "Order collected"
                                        ? "timeline-badge success"
                                        : "timeline-badge"
                                    }
                                  ></div>
                                  <div className="timeline-box">
                                    <span className="timeline-panel">
                                      <div className="text-2 fw-6">
                                        Enquiry Submitted
                                      </div>
                                      <span>
                                        {formatDateToMMDDYYYY(
                                          orderDate?.toString()
                                        )}
                                      </span>
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div
                                    className={
                                      localconfirmedOrder?.order_status ===
                                        "Contacted" ||
                                      localconfirmedOrder?.order_status ===
                                        "Bill Created" ||
                                      // order?.order_status === "New Order" ||
                                      localconfirmedOrder?.order_status ===
                                        "Confirmed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Viewed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Order Packed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Delivery Assigned" ||
                                      localconfirmedOrder?.order_status ===
                                        "Dispatching" ||
                                      localconfirmedOrder?.order_status ===
                                        "Despatched" ||
                                      localconfirmedOrder?.order_status ===
                                        "Delivered" ||
                                      localconfirmedOrder?.order_status ===
                                        "Order collected"
                                        ? "timeline-badge success"
                                        : "timeline-badge"
                                    }
                                  ></div>
                                  <div className="timeline-box">
                                    <span className="timeline-panel">
                                      <div className="text-2 fw-6">
                                        Contacted
                                      </div>
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div
                                    className={
                                      localconfirmedOrder?.order_status ===
                                        "Bill Created" ||
                                      // order?.order_status === "New Order" ||
                                      localconfirmedOrder?.order_status ===
                                        "Confirmed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Viewed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Order Packed" ||
                                      localconfirmedOrder?.order_status ===
                                        "Delivery Assigned" ||
                                      localconfirmedOrder?.order_status ===
                                        "Dispatching" ||
                                      localconfirmedOrder?.order_status ===
                                        "Despatched" ||
                                      localconfirmedOrder?.order_status ===
                                        "Delivered" ||
                                      localconfirmedOrder?.order_status ===
                                        "Order collected"
                                        ? "timeline-badge success"
                                        : "timeline-badge"
                                    }
                                  ></div>
                                  <div className="timeline-box">
                                    <span className="timeline-panel">
                                      <div className="text-2 fw-6">
                                        Bill Created
                                      </div>
                                    </span>
                                  </div>
                                </li>
                              </>
                            )}
                            {localconfirmedOrder?.order_type !==
                              "Custom Orders" && (
                              <li>
                                <div
                                  className={
                                    localconfirmedOrder?.order_status ===
                                      "New Order" ||
                                    // localconfirmedOrder?.order_status === "Failed" ||
                                    localconfirmedOrder?.order_status ===
                                      "Confirmed" ||
                                    localconfirmedOrder?.order_status ===
                                      "Viewed" ||
                                    localconfirmedOrder?.order_status ===
                                      "Order Packed" ||
                                    localconfirmedOrder?.order_status ===
                                      "Delivery Assigned" ||
                                    localconfirmedOrder?.order_status ===
                                      "Dispatching" ||
                                    localconfirmedOrder?.order_status ===
                                      "Despatched" ||
                                    localconfirmedOrder?.order_status ===
                                      "Delivered" ||
                                    localconfirmedOrder?.order_status ===
                                      "Order collected"
                                      ? "timeline-badge success"
                                      : "timeline-badge"
                                  }
                                ></div>
                                <div className="timeline-box">
                                  <div className="text-2 fw-6">
                                    Order is Pending
                                  </div>
                                  {localconfirmedOrder?.order_type !==
                                    "Custom Orders" && (
                                    <>
                                      <span>
                                        {formatDateToMMDDYYYY(
                                          orderDate?.toString()
                                        )}
                                      </span>
                                    </>
                                  )}
                                </div>
                              </li>
                            )}

                            <li>
                              <div
                                className={
                                  localconfirmedOrder?.order_status ===
                                    "Confirmed" ||
                                  localconfirmedOrder?.order_status ===
                                    "Viewed" ||
                                  localconfirmedOrder?.order_status ===
                                    "Order Packed" ||
                                  localconfirmedOrder?.order_status ===
                                    "Delivery Assigned" ||
                                  localconfirmedOrder?.order_status ===
                                    "Dispatching" ||
                                  localconfirmedOrder?.order_status ===
                                    "Despatched" ||
                                  localconfirmedOrder?.order_status ===
                                    "Delivered" ||
                                  localconfirmedOrder?.order_status ===
                                    "Order collected"
                                    ? "timeline-badge success"
                                    : "timeline-badge"
                                }
                              ></div>
                              <div className="timeline-box">
                                <div className="text-2 fw-6">
                                  Order is Placed
                                </div>
                                {/* <span>
                              {formatDateToMMDDYYYY(orderDate?.toString())}
                            </span> */}
                              </div>
                            </li>
                            <li>
                              <div
                                className={
                                  localconfirmedOrder?.order_status ===
                                    "Viewed" ||
                                  localconfirmedOrder?.order_status ===
                                    "Order Packed" ||
                                  localconfirmedOrder?.order_status ===
                                    "Delivery Assigned" ||
                                  localconfirmedOrder?.order_status ===
                                    "Dispatching" ||
                                  localconfirmedOrder?.order_status ===
                                    "Despatched" ||
                                  localconfirmedOrder?.order_status ===
                                    "Delivered" ||
                                  localconfirmedOrder?.order_status ===
                                    "Order collected"
                                    ? "timeline-badge success"
                                    : "timeline-badge"
                                }
                              ></div>
                              <div className="timeline-box">
                                <div className="text-2 fw-6">
                                  Order Accepted
                                </div>
                                {/* <span>10/07/2024 4:30pm</span> */}
                              </div>
                            </li>
                            <li>
                              <div
                                className={
                                  localconfirmedOrder?.order_status ===
                                    "Order Packed" ||
                                  localconfirmedOrder?.order_status ===
                                    "Delivery Assigned" ||
                                  localconfirmedOrder?.order_status ===
                                    "Dispatching" ||
                                  localconfirmedOrder?.order_status ===
                                    "Despatched" ||
                                  localconfirmedOrder?.order_status ===
                                    "Delivered" ||
                                  localconfirmedOrder?.order_status ===
                                    "Order collected"
                                    ? "timeline-badge success"
                                    : "timeline-badge"
                                }
                              ></div>
                              <div className="timeline-box">
                                <div className="text-2 fw-6">
                                  Order is Packed
                                </div>
                                {/* <span>10/07/2024 4:30pm</span> */}
                              </div>
                            </li>
                            {localconfirmedOrder?.order_type === "Pick Up" ? (
                              <>
                                <li>
                                  <div
                                    className={
                                      localconfirmedOrder?.order_status ===
                                      "Order collected"
                                        ? "timeline-badge success"
                                        : "timeline-badge"
                                    }
                                  ></div>
                                  <div className="timeline-box">
                                    <span className="timeline-panel">
                                      <div className="text-2 fw-6">
                                        Order Collected
                                      </div>
                                      <span>
                                        {convertDateToMMDDYYYY(
                                          localconfirmedOrder?.delivery_slot_date
                                        )}
                                      </span>
                                      &nbsp;
                                      <span>
                                        {convertTimeTo12HourFormat(
                                          localconfirmedOrder?.delivery_slot_time
                                        )}
                                      </span>
                                    </span>
                                  </div>
                                </li>
                              </>
                            ) : (
                              <>
                                <li>
                                  <div
                                    className={
                                      localconfirmedOrder?.order_status ===
                                        "Delivery Assigned" ||
                                      localconfirmedOrder?.order_status ===
                                        "Dispatching" ||
                                      localconfirmedOrder?.order_status ===
                                        "Despatched" ||
                                      localconfirmedOrder?.order_status ===
                                        "Delivered"
                                        ? "timeline-badge success"
                                        : "timeline-badge"
                                    }
                                  ></div>
                                  <div className="timeline-box">
                                    <span className="timeline-panel">
                                      <div className="text-2 fw-6">
                                        Delivery Assigned
                                      </div>
                                      {/* <span>11/07/2024 2:36pm</span> */}
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div
                                    className={
                                      localconfirmedOrder?.order_status ===
                                      "Delivered"
                                        ? "timeline-badge success"
                                        : "timeline-badge"
                                    }
                                  ></div>
                                  <div className="timeline-box">
                                    <span className="timeline-panel">
                                      <div className="text-2 fw-6">
                                        Order Delivered
                                      </div>
                                      <span>
                                        {convertDateToMMDDYYYY(
                                          localconfirmedOrder?.delivery_slot_date
                                        )}
                                      </span>
                                      &nbsp;
                                      <span>
                                        {convertTimeTo12HourFormat(
                                          localconfirmedOrder?.delivery_slot_time
                                        )}
                                      </span>
                                    </span>
                                  </div>
                                </li>
                              </>
                            )}
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {localconfirmedOrder?.grand_total && (
                <>
                  <div className="col-md-4 modal-shopping-cart">
                    <div className="wrap">
                      <div className="tf-mini-cart-wrap card">
                        <div className="tf-mini-cart-bottom">
                          <div className="tf-mini-cart-bottom-wrap">
                            <div style={{ margin: "10px" }}>
                              <div className="d-flex justify-content-between align-items-center">
                                <h3>Bill Details</h3>
                                {downloading ? (
                                  // <span style={{ color: "#040404f6", fontSize: "14px" }}>Downloading...</span>
                                  <CircularProgress
                                    variant="determinate"
                                    value={progress}
                                  />
                                ) : (
                                  <DownloadIcon
                                    style={{
                                      cursor: "pointer",
                                      color: "#040404f6",
                                    }}
                                    onClick={handleDownload}
                                  />
                                )}
                              </div>

                              <div className="tf-cart-totals-discounts">
                                <div className="tf-cart-total">Item Total</div>
                                <div className="tf-totals-total-value fw-6">
                                  ₹{localconfirmedOrder?.sub_total}{" "}
                                </div>
                              </div>
                              <div className="tf-cart-totals-discounts">
                                <div>Delivery Fee</div>
                                <div>
                                  ₹{localconfirmedOrder?.delivery_charges}
                                </div>
                              </div>
                              <hr />
                              {/* <div className="tf-cart-totals-discounts">
                        <div>Platform Fee</div>
                        <div>0.00</div>
                      </div> */}
                              <div className="tf-cart-totals-discounts">
                                <div>GST and Restaurant charges</div>
                                <div>
                                  ₹
                                  {localconfirmedOrder?.taxes_and_charges
                                    ? Number(
                                        localconfirmedOrder.taxes_and_charges
                                      ).toFixed(2)
                                    : ""}
                                </div>
                              </div>
                              <hr />
                              <div className="tf-cart-totals-discounts">
                                <div className="tf-cart-total fw-6">Total</div>
                                <div className="tf-totals-total-value fw-6">
                                  ₹{localconfirmedOrder?.grand_total}{" "}
                                </div>
                              </div>
                              {/* <div className="tf-mini-cart-view-checkout">
                        <div className="tf-btn  animate-hover-btn radius-3 w-100 justify-content-center orange-b btn-add-note">
                          <span>You have saved ₹85.15</span>
                        </div>
                      </div> */}
                              {localconfirmedOrder.order_status ===
                                "Bill Created" && (
                                <div className="mt-3">
                                  <hr />
                                  <div className="fs-6 mt-4 mb-4 fw-6">
                                    Choose Payment Method
                                  </div>
                                  {/* Render available payment modes as radio buttons */}
                                  <FormControl
                                    component="fieldset"
                                    sx={{ mb: 2 }}
                                  >
                                    <RadioGroup
                                      aria-label="payment-mode"
                                      name="payment-mode"
                                      value={
                                        selectedPaymentModeId !== null
                                          ? String(selectedPaymentModeId)
                                          : ""
                                      }
                                      onChange={(e) =>
                                        setSelectedPaymentModeId(
                                          Number(e.target.value)
                                        )
                                      }
                                    >
                                      {(availablePaymentModes || []).map(
                                        (mode: any) => (
                                          <FormControlLabel
                                            key={mode.id}
                                            value={String(mode.id)}
                                            control={<Radio />}
                                            label={mode.mode_name}
                                          />
                                        )
                                      )}
                                    </RadioGroup>
                                  </FormControl>
                                  <div className="tf-mini-cart-view-checkout">
                                    <a
                                      className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"
                                      onClick={() =>
                                        handleCheckoutClick(
                                          localconfirmedOrder?.order_ID
                                        )
                                      }
                                    >
                                      <span>
                                        {" "}
                                        {selectedPaymentModeId == 1
                                          ? "Confirm Order"
                                          : "Proceed to Pay"}
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
};
